import React, { useContext, useEffect } from "react";
import { getCurrentLanguageId } from "../../lang/utils";
import { useAppDispatch } from "../../store/store";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Box from "../../UI/Box";
import {
  getCondimentDetails,
  getCondimentDetailsStatus,
} from "../../components/CondimentDetails/selectors";
import { fetchHarmonyCondiments } from "../../components/Condiment/actions";
import { fetchOneCondimentById } from "../../components/CondimentDetails/actions";
import {
  getCondiments,
  getIsLoadingCondiments,
} from "../../components/Condiment/selectors";
import CondimentWrapper from "../../components/Condiment/CondimentWrapper";
import { getValueForKey } from "../../context/translationsUtils";
import { TranslationContext } from "../../context/TranslationContext";
import { TranslationContextInterface } from "../../entities/Language";
import HarmonyDetailsInfo from "../../components/HarmonyDetailsInfo";
import SkeletonComponent from "../../components/SkeletonComponent";
import CondimentSkeleton from "../../components/Condiment/CondimentSkeleton";
import { setBreadcrumbs } from "../../components/Breadcrumbs/slice/BreadcrumbsSlice";
import { getAsideData } from "../../components/Aside/slice/selectors";

const HarmonyDetails: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const languageId = getCurrentLanguageId();
  const dispatch = useAppDispatch();
  const { harmonyId } = useParams<{ harmonyId: string }>();
  const { spices = [], herbs = [] } = useSelector(getCondiments);
  const { asideCategories = [] } = useSelector(getAsideData);
  const tasteHarmonCategory = asideCategories.find((item) => item.id === 5);

  const isLoading = useSelector(getIsLoadingCondiments);
  const isLoadingOneCondiment = useSelector(getCondimentDetailsStatus);

  const condiment = useSelector(getCondimentDetails);

  useEffect(() => {
    if (harmonyId) {
      dispatch(fetchHarmonyCondiments(harmonyId));
      dispatch(fetchOneCondimentById(harmonyId));
    }
  }, [languageId, harmonyId, dispatch]);

  useEffect(() => {
    if (condiment && tasteHarmonCategory) {
      dispatch(
        setBreadcrumbs({
          name: tasteHarmonCategory.name,
          link: tasteHarmonCategory.to,
          level: 0,
        }),
      );
      dispatch(setBreadcrumbs({ name: condiment.name, link: null, level: 1 }));
    }
  }, [languageId, dispatch, condiment, tasteHarmonCategory]);

  return (
    <Box>
      <SkeletonComponent
        isLoading={isLoadingOneCondiment}
        skeleton={<CondimentSkeleton />}
      >
        {condiment && <HarmonyDetailsInfo condiment={condiment} />}
      </SkeletonComponent>
      <SkeletonComponent isLoading={isLoading} skeleton={<CondimentSkeleton />}>
        <CondimentWrapper
          title={getValueForKey(translations, "custom.choose_spices_hint")}
          condiments={spices}
          disableSelected={true}
        />
        <CondimentWrapper
          title={getValueForKey(translations, "custom.choose_herbs_hint")}
          condiments={herbs}
          disableSelected={true}
        />
      </SkeletonComponent>
    </Box>
  );
};

export default HarmonyDetails;
